import React, { FC, ReactNode } from "react";
import { FlowioInputType } from "src/globalTypes";
import FlowioInput from "../FlowioInput";
import UndecoratedFlowioTableCellInput, {
  FlowioTableCellInputProps,
} from "./UndecoratedFlowioTableCellInput";
import { ColorBox } from "./styles";
import { couldBeColorInput, couldBeIconInput, matchSelectItem } from "./utils";

type Val = string | number | null;

type FlowioTableCellInputFCProps = FlowioTableCellInputProps & {
  children: ReactNode;
};

const ColorDecorator = (props: FlowioTableCellInputFCProps) => {
  const { format, unformattedValue, editable, onBlur, children } = props;

  if (couldBeColorInput(format, editable)) {
    const activeOption = matchSelectItem(
      format.general.colorOptions,
      unformattedValue as Val,
      format.typeSpecific
    );

    if (activeOption) {
      return (
        <ColorBox
          data-cy="color-decoration"
          color={activeOption?.name}
          onBlur={onBlur}
        >
          {children}
        </ColorBox>
      );
    }
  }

  return <React.Fragment>{children}</React.Fragment>;
};

const IconDecorator = (props: FlowioTableCellInputFCProps) => {
  const { format, unformattedValue, editable, onBlur, children } = props;

  if (couldBeIconInput(format, editable)) {
    const activeOption = matchSelectItem(
      format.general.iconOptions,
      unformattedValue as Val,
      format.typeSpecific
    );

    if (activeOption) {
      return (
        <FlowioInput
          type={FlowioInputType.Icon}
          value={activeOption.name}
          noInputMode
        />
      );
    }
  }

  return <React.Fragment>{children}</React.Fragment>;
};

const DecoratedFlowioTableCellInput: FC<FlowioTableCellInputProps> = (
  props
) => (
  <ColorDecorator {...props}>
    <IconDecorator {...props}>
      <UndecoratedFlowioTableCellInput {...props} />
    </IconDecorator>
  </ColorDecorator>
);

export default DecoratedFlowioTableCellInput;
